<template>
    <component
        :is="tag"
        ref="contentEditable"
        :contenteditable="editable"
        :class="cssClass"
        :style="cssStyle"
        v-bind="forwardedAttrs"
        v-on="forwardedListeners">
    </component>
</template>

<script>
export default {
    name: "Editable",
    inheritAttrs: false,
    props: {
        modelValue: {
            type: String,
            default: undefined,
        },
        tag: {
            type: String,
            default: "div",
        },
        value: {
            type: String,
            default: "",
        },
        editable: {
            type: Boolean,
            default: true,
        },
        cssClass: {
            type: String,
            default: "",
        },
        cssStyle: {
            type: String,
            default: "",
        },
        maxLength: {
            type: Number,
            default: null,
        },
    },
    computed: {
        currentValue() {
            return this.modelValue ?? this.value ?? "";
        },
        forwardedAttrs() {
            return Object.fromEntries(Object.entries(this.$attrs).filter(([key]) => !key.startsWith("on")));
        },
        forwardedListeners() {
            return {
                ...Object.fromEntries(
                    Object.entries(this.$attrs).filter(([key, value]) => {
                        if (!key.startsWith("on") || key === "onInput" || key === "onUpdate:modelValue") {
                            return false;
                        }

                        return typeof value === "function" || (Array.isArray(value) && value.every((listener) => typeof listener === "function"));
                    })
                ),
                input: [this.onInput],
            };
        },
    },
    methods: {
        getRef() {
            return this.$refs.contentEditable;
        },
        onInput(e) {
            let content = e.target.innerText;

            if (this.maxLength !== null && content.length > this.maxLength) {
                this.setContent((content = content.substr(0, this.maxLength)));
            }

            this.$emit("input", content);
            this.$emit("update:modelValue", content);
        },
        setContent(content) {
            const target = this.getRef();

            if (!target) {
                return;
            }

            const nextContent = content ?? "";

            if (target.innerText !== nextContent) {
                target.innerText = nextContent;
            }
        },
    },
    mounted() {
        this.setContent(this.currentValue);
    },
    watch: {
        currentValue(newValue) {
            this.setContent(newValue);
        },
    },
};
</script>
